export const SHOULD_SHOW_CONFIGURATION_MODAL = 'shouldShowConfigurationModal';

export const SAMPLE_DATA_BULK_DELETE_USER_PROPERTY_KEY =
	'jira.onboarding.sample.data.bulk.delete.tenant.CLOUD_ID.project.PROJECT_ID';
